<template>
    <button v-if="!expired"
            type="button"
            role="button"
            class="btn btn-secondary"
            :class="{ loading: cancellingReservedAppointment }"
            @click.prevent="sendCancelReservedAppointmentRequest"
    >Change appointment</button>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'change-appointment-button',

        data() {
            return {
                expired: false,
            };
        },

        computed: {
            ...mapState('appointment', [
                'appointmentData',
            ]),

            ...mapState('appointments', [
                'cancellingReservedAppointment',
            ]),
        },

        mounted() {
            this.listen('appointment.expired', this.handleExpired);
            this.listen('appointment.refreshed', this.handleRefreshed);
        },

        destroyed() {
            this.silence('appointment.expired', this.handleExpired);
            this.silence('appointment.refreshed', this.handleRefreshed);
        },

        methods: {
            ...mapActions('appointments', [
                'cancelReservedAppointment',
            ]),

            sendCancelReservedAppointmentRequest() {
                const appointmentId = this.appointmentData.appointment.AppointmentID;

                const callback = () => this.$router.push({ name: 'home' });

                this.cancelReservedAppointment({ appointmentId, callback });
            },

            handleExpired() {
                this.expired = true;
            },

            handleRefreshed() {
                this.expired = false;
            },
        },
    }
</script>
